module.exports = "/_next/static/images/empty_state_event-1d3b4c8a804c0b6b27befe5b686d1bd2.svg";